function keyMirror (obj) {
  if (obj instanceof Object) {
    const _obj = Object.assign({}, obj)
    Object.keys(obj).forEach((key) => {
      _obj[key] = key
    })
    return _obj
  }
}

export default keyMirror({
  USER_INFO: null,
  USER_LOGOUT: null,
  SOCKET_LIST: null,
  WS_STATUS: null,
  WS_MESSAGE: null,
  WS_LOADING: null,
  CLEAR_NEW_TIPS: null,
  CLEAR_MESSAGE_KEY: null,
  CLEAR_CHAT_MESSAGE: null,
  GIFT_MESSAGE: null,
  SOCKET_LIVE_AD: null,
  CLEAR_GIFT_MESSAGE: null,
  UPDATE_PROTON: null,
  UPDATE_HAS_TIPS: null,
  UPDATE_FABULOUS: null,
  START_SOCKET: null,
  UPDATE_APPLAUSE: null,
  QUESTION_PARAMS: null,
  PROTON_AWARDS_MSG: null,
  WS_CONNECTED_STATUS: null
})
